<template>
  <div class="pay-result container">
    <div class="result-area">
      <div class="result-title fl-center">
        <el-image :src="rightIcon"></el-image>
        <span>支付成功 待酒店受理 Successful Payment Pending Hotel acceptance</span>
      </div>
      <div class="result-title-chdesc">酒店确认后方为预订成功 请注意关注消息提醒 Please pay attention to the message alert when the hotel confirms the reservation is successful</div>
    </div>
    <div class="hotel-notice" v-html="notice" v-if="notice"></div>
    <div class="result-btns fl-center">
      <el-button class="result-btn-item mar-r-100" @click="toShopIndex"> 返回首页 Back to first page </el-button>
      <el-button class="result-btn-item" @click="toOrder"> 查看订单 Look at the order </el-button>
    </div>
  </div>
</template>

<script>
import rightIcon from "@/assets/img/right-icon.png";
export default {
  name: "PayResult",
  components: {},
  data() {
    return {
      rightIcon: rightIcon,
      goodsList: [],
      notice: "",
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.getHotelAlertOrder();
  },
  methods: {
    toShopIndex() {
      this.$router.replace("/home");
    },
    toOrder() {
      this.$router.replace(`/my-profile/order?activeValue=2`);
    },
    async getHotelAlertOrder() {
      let { data } = await this.$api.getHotelAlertOrder();
      this.notice = data ? data.replaceAll("\n", "<br>") : "";
      // console.log("this.notice", this.notice);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.pay-result {
  background: #fff;
  .result-title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    margin-top: 104px;
    text-align: center;
    padding-left: 60px;
    .el-image {
      width: 30px;
      height: 30px;
      margin-right: 30px;
    }
    padding-bottom: 60px;
  }
  .hotel-notice {
    padding: 60px 0;
    border-bottom: 1px solid #f0f0f0;
    line-height: 2;
    margin-left: 30px;
  }
  .result-btns {
    margin-top: 60px;
  }
  .mar-r-100 {
    margin-right: 100px;
  }
  .guide-list {
    margin-top: 100px;
    padding-bottom: 90px;
  }
  .result-title-chdesc {
    text-align: center;
    padding-bottom: 58px;
    border-bottom: 1px solid #f0f0f0;
  }
}
</style>
